<!--
  v2 格式通知渲染（version === 2）
  契约文档：docs/plans/ai-solution/ai-solution-message-notification-contract.md
  覆盖场景：§1 通过审核 ~ §11 评论因举报被下线（messageType 18–28）
-->
<script lang="ts" setup>
import { computed } from '#imports';
import type { MessageJumpVo, UserMessageVo } from '@core/types/auto/forum';
import { parseTemplate, renderTemplate } from '@core/utils/message';
import HTMessageText from './HTMessageText.vue';

const props = defineProps<{ item: UserMessageVo }>();

const emit = defineEmits<{
  (e: 'inline-click', jump: MessageJumpVo): void;
}>();

const titleTokens = computed(() =>
  parseTemplate(props.item.title, props.item.params, props.item.inlineJumps),
);

const subtitleTokens = computed(() =>
  parseTemplate(props.item.subtitle, props.item.params, props.item.inlineJumps),
);

const subtitleText = computed(() =>
  renderTemplate(props.item.subtitle, props.item.params),
);
</script>

<template>
  <div class="break-words font-semibold">
    <HTMessageText
      :tokens="titleTokens"
      @inline-click="emit('inline-click', $event)"
    />
  </div>
  <a-tooltip :title="subtitleText">
    <div class="text-subtitle truncate">
      <HTMessageText
        :tokens="subtitleTokens"
        @inline-click="emit('inline-click', $event)"
      />
    </div>
  </a-tooltip>
</template>
